export default __webpack_public_path__ + "static/media/hailoffuriousstrikes1.bb0f4331.png";